import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useGetDocumentSettings = (enabled = true) => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.DocumentSettings], () => api.base
        .get(`${config.appUrls.documents}/api/settings/`)
        .then(res => res.data), {
        enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
